module.exports = __webpack_public_path__ + "static/media/cta_hero.6da39010.png";